<template>
	<div class="page">
		<MainHeader v-bind:page="'Contact'"></MainHeader>
		<div class="container">
			<div class="row">
				<div class="whole component">
					<img :src="headerImage" width="938px" />
					<br><br>
					<p>Welkom bij Herberg van het Hart</p>
					<p>Voor informatie over begeleiding Talentenspel gelieve te mailen of bellen </p>
					<p>Tel: <br> +31(0)6-53574848<br><br>
					Email: <br>suzette@herbergvanhethart.eu<br><br>
					Adres: <br> Goudbaard 82 <br>
					4625 GC <br> Bergen op Zoom</p>
					<br><br><br><br><br><br><br><br>
					<p style="text-align: center"><i>De schat die iemand in zijn diepste kern is helpen zichtbaar, hoorbaar en ervaarbaar te maken.<br>
					~ Suzette Frijters ~</i></p>


                </div>
            </div>
		</div>
		<MainFooter style="display:flex; margin-left: auto; margin-right:auto;"></MainFooter>
	</div>
</template>

<script>
import MainHeader from '../MainHeader';
import MainFooter from '../MainFooter';
import ContactForm from '../ContactForm';

export default {
	name: 'Contact',
	data() {
		return {
			headerImage: require('../../img/contact_header.jpg')
			// contactForm: require('../../contact-form/formpage.html')
		}
	},
	computed: {
	},
	methods: {
	},
	components: {
		MainHeader, MainFooter, ContactForm
	}
}
</script>

<style lang="less">

#contact-form-wrapper {
	float: left;
	margin-right: 15px;
}
.form-frame {
	margin: 0;
	padding: 0;
	border: none;
	width: 400px;
	height: 500px;
	display: block;
	margin: auto;
}


.form-container
{
	background: #3085B7;
	border-radius: 5px;
	padding: 15px;
	width: 400px;
	text-align: center;
	float: left;
}

.form-title {
    color: white;
    font-size: 20pt;
    margin-top: 0;
    font-weight: normal;
}

label {
    color: white;
    font-size: 16pt;
    font-weight: normal;
}

.form-input {
	width: 100%;
	border-radius: 4px;
	height: 34px;
	margin: 10px 0;
}

.form-button {
	border-radius: 6px;
	height: 44px;
	color: #333;
	font-size: 18px;
	font-family: Helvetica;
	cursor:pointer;
}

</style>




// WEBPACK FOOTER //
// src/components/pages/Contact.vue